// extracted by mini-css-extract-plugin
export default {"rightbordershadow":"InvoiceCreate_rightbordershadow__hqfRW","createModal":"InvoiceCreate_createModal__ce6Mv"};